import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ListViewModule } from '@syncfusion/ej2-angular-lists';
import { RecherchePatientPage } from '../recherche-patient/recherche-patient.page';

@NgModule({
  declarations: [RecherchePatientPage],
  entryComponents: [RecherchePatientPage],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ListViewModule
  ],
  exports: [RecherchePatientPage]
})
export class SharedPatientSearchModule {}